import { render, staticRenderFns } from "./CaptureConfirm.vue?vue&type=template&id=235c4288"
import script from "./CaptureConfirm.vue?vue&type=script&lang=js"
export * from "./CaptureConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports